(function () {
  'use strict';

  var requestState = new WeakMap();

  function updateVariantTooltips(root) {
    var scope = root || document;
    var labels = scope.querySelectorAll('.main-product__right .xo-product-info-content__variants .xo-field-radio--boxed2[data-variant-tooltip]');

    Array.prototype.forEach.call(labels, function (label) {
      var text = label.querySelector('.xo-field-radio__label > span');
      if (!text) return;

      var isOverflowing = text.scrollWidth > text.clientWidth + 1;
      if (isOverflowing) {
        label.setAttribute('data-option-overflow', '');
      } else {
        label.removeAttribute('data-option-overflow');
      }
    });
  }

  function parseProductData(productRoot) {
    var script = productRoot.querySelector('xo-product-data script[type="application/json"]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent.replace(/,\s*([}\]])/g, '$1'));
    } catch (error) {
      console.error('[PDP variant sync] Invalid product data.', error);
      return null;
    }
  }

  function selectedOptions(productRoot) {
    var container = productRoot.querySelector('.xo-product-info-content__variants');
    if (!container) return [];

    var controls = Array.prototype.slice.call(container.querySelectorAll('input[name], select[name]'));
    var names = [];

    controls.forEach(function (control) {
      if (names.indexOf(control.name) === -1) names.push(control.name);
    });

    return names.map(function (name) {
      var matching = controls.filter(function (control) {
        return control.name === name;
      });
      var selected = matching.filter(function (control) {
        return control.tagName === 'SELECT' || control.checked;
      })[0];
      return selected ? selected.value : null;
    });
  }

  function findVariant(productRoot) {
    var data = parseProductData(productRoot);
    if (!data || !Array.isArray(data.variants)) return null;

    var options = selectedOptions(productRoot);
    if (!options.length || options.indexOf(null) !== -1) return null;

    return data.variants.filter(function (variant) {
      return Array.isArray(variant.options) && variant.options.every(function (value, index) {
        return value === options[index];
      });
    })[0] || null;
  }

  function setVariantIds(productRoot, variantId) {
    Array.prototype.forEach.call(productRoot.querySelectorAll('form[action*="/cart/add"] input[name="id"]'), function (input) {
      input.value = String(variantId);
      input.setAttribute('value', String(variantId));
    });
  }

  function copyAttributes(target, source) {
    Array.prototype.slice.call(target.attributes).forEach(function (attribute) {
      target.removeAttribute(attribute.name);
    });
    Array.prototype.slice.call(source.attributes).forEach(function (attribute) {
      target.setAttribute(attribute.name, attribute.value);
    });
  }

  function nodesWithUniqueId(root, id) {
    return Array.prototype.filter.call(root.querySelectorAll('xo-product-will-change[xo-unique-id]'), function (node) {
      return node.getAttribute('xo-unique-id') === id;
    });
  }

  function applySectionResponse(productRoot, html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var productId = productRoot.getAttribute('xo-product-id');
    var sourceRoot = parsed.querySelector('xo-product[xo-product-information][xo-product-id="' + productId + '"]');
    if (!sourceRoot) return false;

    var ids = [];
    Array.prototype.forEach.call(productRoot.querySelectorAll('xo-product-will-change[xo-unique-id]'), function (node) {
      var id = node.getAttribute('xo-unique-id');
      if (ids.indexOf(id) === -1) ids.push(id);
    });

    ids.forEach(function (id) {
      var currentNodes = nodesWithUniqueId(productRoot, id);
      var sourceNodes = nodesWithUniqueId(sourceRoot, id);
      if (!sourceNodes.length) return;

      currentNodes.forEach(function (currentNode, index) {
        var sourceNode = sourceNodes[Math.min(index, sourceNodes.length - 1)];
        copyAttributes(currentNode, sourceNode);
        currentNode.innerHTML = sourceNode.innerHTML;
      });
    });

    if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
      window.Shopify.PaymentButton.init();
    }
    updateVariantTooltips(productRoot);
    return true;
  }

  function sectionUrl(productRoot, variantId) {
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    url.searchParams.set('section_id', productRoot.getAttribute('xo-section-id'));
    return url.pathname + '?' + url.searchParams.toString();
  }

  function updateBrowserUrl(variantId) {
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    url.searchParams.delete('section_id');
    window.history.replaceState({}, '', url.pathname + '?' + url.searchParams.toString() + url.hash);
  }

  function refreshVariant(productRoot) {
    var variant = findVariant(productRoot);
    if (!variant) return;

    setVariantIds(productRoot, variant.id);
    updateBrowserUrl(variant.id);

    var previous = requestState.get(productRoot);
    if (previous) previous.abort();

    var controller = new AbortController();
    requestState.set(productRoot, controller);

    fetch(sectionUrl(productRoot, variant.id), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: controller.signal
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Section request failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        if (requestState.get(productRoot) !== controller) return;
        if (!applySectionResponse(productRoot, html)) throw new Error('Product section was not found in the response.');
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') console.error('[PDP variant sync]', error);
      });
  }

  document.addEventListener('change', function (event) {
    var variants = event.target.closest('.xo-product-info-content__variants');
    if (!variants) return;

    var productRoot = variants.closest('xo-product[xo-product-information]');
    if (!productRoot) return;

    window.setTimeout(function () {
      refreshVariant(productRoot);
    }, 0);
  }, true);

  var resizeFrame = null;
  window.addEventListener('resize', function () {
    if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(function () {
      updateVariantTooltips(document);
      resizeFrame = null;
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    updateVariantTooltips(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updateVariantTooltips(document);
    });
  } else {
    updateVariantTooltips(document);
  }
})();
